// extracted by mini-css-extract-plugin
module.exports = {"content":"Custom_02_content__3ZL1j"};